import translate from "@noar-firmenich/commons";
import store from '../../store/store';
//Conter entre 8 e 16 caracteres;
//Conter numerais;
//Conter letras minúsculas e maiúsculas;
//Caracteres especiais ?=.*[]#$ ^+=!()+@-%&

const hasNecessaryCharacters = text => {
  return text.length >= 8 && text.length <= 16;
};

const hasNumeral = text => {
  return /\d/.test(text);
};

const hasUppercaseAndLowercase = text => {
  return /[a-z]/.test(text) && /[A-Z]/.test(text);
};

const hasSpecialCharacter = text => {
  // eslint-disable-next-line
  const regexPattern = /[ `!@#$%^&*()_\-=\.?]/;
  return regexPattern.test(text);
};

export function IsValidPassword(password) {
  const locale = store.getState().i18n.lang

  console.log(store);
  const errorList = {
    necessaryCharacter: translate(locale).alterPassword.necessaryChar,
    hasNumeral: translate(locale).alterPassword.hasNumeral,
    hasCases: translate(locale).alterPassword.hasUpperChar,
    hasSpecialCharacter: translate(locale).alterPassword.hasEspecialChar,
    mensageErros: 'ERROS_FOUND'
  }
  const errorsExpected = {
    [errorList.necessaryCharacter]: true,
    [errorList.hasNumeral]: true,
    [errorList.hasCases]: true,
    [errorList.hasSpecialCharacter]: true,
    [errorList.mensageErros]:[]
  }

  let errorsActual = errorsExpected;
  var mensageErrosActual = errorsActual.ERROS_FOUND
  const setErrorIn = key => {
    mensageErrosActual.push(key)
      errorsActual = {
      ...errorsActual,
      [key]: false,
      'ERROS_FOUND': mensageErrosActual
    }
  };


  if (!hasNecessaryCharacters(password)) {
    setErrorIn(errorList.necessaryCharacter);
  }

  if (!hasNumeral(password)) {
    setErrorIn(errorList.hasNumeral);
  }

  if (!hasUppercaseAndLowercase(password)) {
    setErrorIn(errorList.hasCases);
  }

  if (!hasSpecialCharacter(password)) {
    setErrorIn(errorList.hasSpecialCharacter);
  }

  if (errorsExpected === errorsActual) {
    return true;
  } else {
    return errorsActual;
  }
};
